import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAgentAddPayload, IAgentUpdatePayload } from './agenti-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class AgentiProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listAgentiURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.list;
    private listDTAgentiURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.listDT;
    private addAgentURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.store;
    private updateAgentURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.update;
    private deleteAgentURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.delete;
    private changeStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.changeActive;
    private listStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteAgent.listActive;

    constructor(private http: HttpClient) { }

    listAgenti() {
        return this.http.get(this.listAgentiURL);
    }

    listDTAgenti() {
        return this.http.post(this.listDTAgentiURL, {});
    }

    addAgent(data: IAgentAddPayload) {
        return this.http.post(this.addAgentURL, data);
    }

    updateAgent(data: IAgentUpdatePayload) {
        return this.http.put(this.updateAgentURL, data);
    }

    deleteAgent(id: number) {
        return this.http.delete(this.deleteAgentURL + id);
    }

    listStatusActive() {
        return this.http.get(this.listStatusActiveURL);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveURL + id);
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
